import update from 'immutability-helper';
import { createAction } from '~reduxHelpers';
import * as api from '~services/api'; // eslint-disable-line

// Action types
/* eslint-disable max-len */
export const TOAST_ADD_MESSAGE = 'TOAST_ADD_MESSAGE';
export const TOAST_REMOVE_MESSAGE = 'TOAST_REMOVE_MESSAGE';
/* eslint-enable max-len */

export const initialState = {
  messages: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOAST_ADD_MESSAGE:
      return update(state, {
        messages: {
          $push: [
            {
              message: action.payload.message,
              timeout: action.payload.timeout,
              type: action.payload.type || 'INFO',
              id: new Date().getUTCMilliseconds(),
            },
          ],
        },
      });
    case TOAST_REMOVE_MESSAGE: {
      const newMessages = state.messages.filter(
        msg => msg.id !== action.payload
      );

      return update(state, { messages: { $set: newMessages } });
    }
    default:
      return state;
  }
}

// Actions
/* eslint-disable max-len */
export const addToast = createAction(TOAST_ADD_MESSAGE);
export const removeToast = createAction(TOAST_REMOVE_MESSAGE);
/* eslint-enable max-len */

// Selectors
export const getToasts = state => state.toast.messages;

// Thunks

// export const fetchPhoneAccount = (num) =>
//   async (dispatch) => {
//     dispatch(setLoading(true));

//     try {
//       const account = await api.get(`devices/extensions/${num}`);
//       dispatch(receivePhoneAccount(account));
//     } catch (e) {
//       console.log('Phone account not found', e);
//       dispatch(setError({
//         message: 'Liittymää ei löytynyt - tarkista numero.',
//       }));
//     }

//     dispatch(setLoading(false));
//   };
